import React, { useContext } from "react";
import * as FaIcons from "react-icons/fa";
import AdminemailLogsContext from "../../context/adminemailLogs/adminemailLogsContext";
import { getAppUrl } from "../../functions/getEnv";

const EmailLogger = ({ formData = {}, history = {} }) => {
  const adminemailLogsContext = useContext(AdminemailLogsContext);
  const { updateEntrie, getEntries } = adminemailLogsContext;
	const appUrl = getAppUrl(import.meta.env.VITE_NODE_ENV);

  const {
    _id,
    createdAt,
    recipientEmail,
    cc,
    bcc,
    resendCount,
    relatedRecordId,
    recordType,
    emailType,
    learningCenterName,
    learningCenterAddress,
    status,
    fromEmail,
    errorMessage,
    brandName,
    content,
    learningCenterId,
    learningCenterCharter,
    subject
  } = formData;

  const goBack = () => {
    if (history.push) {
      history.push("/email-logs");
    } else if (history.goBack) {
      history.goBack();
    }
  };

  const formatDate = (date) => {
    if (!date) return "N/A";
    return new Date(date).toLocaleString();
  };

  const formatEmails = (emails) => {
    if (!emails || emails.length === 0) return "N/A";
    if (Array.isArray(emails)) {
      return emails.join(", ");
    }
    return emails;
  };

  return (
    <div className="interest-form">
      <div className="top-bar">
        <div
          onClick={goBack}
          className="left"
        >
          <FaIcons.FaArrowLeft className="menu-icon" />
          <span>Go Back</span>
        </div>
      </div>

      <h1 className="top-title text-center">Email Log Details</h1>

      {/* Email Information Section */}
      <div className="email-section">
        <h3>Email Information</h3>

        {/* Subject */}
        <div className="field-row white-bg">
          <h4>Subject:</h4>
          <p>{subject || "N/A"}</p>
        </div>

        {/* Recipient Email */}
        <div className="field-row gray-bg">
          <h4>Recipient Email (To):</h4>
          <p>{formatEmails(recipientEmail)}</p>
        </div>

        {/* CC Emails */}
        <div className="field-row white-bg">
          <h4>CC:</h4>
          <p>{formatEmails(cc)}</p>
        </div>

        {/* BCC Emails */}
        <div className="field-row gray-bg">
          <h4>BCC:</h4>
          <p>{formatEmails(bcc)}</p>
        </div>

        {/* From Email */}
        <div className="field-row white-bg">
          <h4>From Email:</h4>
          <p>{fromEmail || "N/A"}</p>
        </div>

        {/* Email Type */}
        <div className="field-row gray-bg">
          <h4>Email Type:</h4>
          <p>{emailType || "N/A"}</p>
        </div>

        {/* Status */}
        <div className="field-row white-bg">
          <h4>Status:</h4>
          <p className={
            status === "Sent" ? "status-sent" :
            status === "Failed" ? "status-failed" :
            "status-default"
          }>
            {status || "N/A"}
          </p>
        </div>

        {/* Created At */}
        <div className="field-row gray-bg">
          <h4>Created At:</h4>
          <p>{formatDate(createdAt)}</p>
        </div>

        {/* Resend Count */}
        {/* {resendCount !== undefined && (
          <div className="field-row white-bg">
            <h4>Resend Count:</h4>
            <p>{resendCount}</p>
          </div>
        )} */}

        {/* Record Type */}
        <div className="field-row gray-bg">
          <h4>Record Type:</h4>
          <p>{recordType || "N/A"}</p>
        </div>

        {/* Related Record ID */}
        <div className="field-row white-bg">
          <h4>Related Record ID:</h4>
          <p>{relatedRecordId || "N/A"}</p>
        </div>

        {/* Error Message */}
        {errorMessage && (
          <div className="field-row error-bg error-row">
            <h4>Error Message:</h4>
            <p>{errorMessage}</p>
          </div>
        )}
      </div>

      {/* Learning Center Information Section */}
      <div className="email-section">
        <h3>Learning Center Information</h3>

        <div className="field-row white-bg">
          <h4>Brand Name:</h4>
          <p>{brandName || "N/A"}</p>
        </div>

        <div className="field-row gray-bg">
          <h4>Charter:</h4>
          <p>{learningCenterCharter || "N/A"}</p>
        </div>

        <div className="field-row white-bg">
          <h4>Site/Learning Center:</h4>
          <p>{learningCenterName || "N/A"}</p>
        </div>

        <div className="field-row gray-bg">
          <h4>Learning Center ID:</h4>
          <p>{learningCenterId || "N/A"}</p>
        </div>

        <div className="field-row white-bg">
          <h4>Address:</h4>
          <p>{learningCenterAddress || "N/A"}</p>
        </div>
      </div>

      {/* Email Content Section */}
      <div className="email-content-section">
        <h3>Email Content</h3>
        <div className="content-display">
          <div
            className="content-html"
            dangerouslySetInnerHTML={{
              __html: content || "<p style='color: #999; font-style: italic;'>No content available</p>"
            }}
          />
        </div>
      </div>
    </div>
  );
};

export default EmailLogger;